import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PendingApprovalTooltipDirective } from './pending-approval-tooltip.directive';



@NgModule({
  declarations: [
    // PendingApprovalTooltipDirective
  ],
  exports:[
    // PendingApprovalTooltipDirective
  ],
  imports: [
    CommonModule
  ]
})
export class DirectivesModule { }
